"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitlePolygon$ = exports.TitlePolygon$outboundSchema = exports.TitlePolygon$inboundSchema = exports.TitlePolygonEpsg4326Polygon$ = exports.TitlePolygonEpsg4326Polygon$outboundSchema = exports.TitlePolygonEpsg4326Polygon$inboundSchema = exports.TitlePolygonEpsg27700Polygon$ = exports.TitlePolygonEpsg27700Polygon$outboundSchema = exports.TitlePolygonEpsg27700Polygon$inboundSchema = void 0;
exports.titlePolygonEpsg27700PolygonToJSON = titlePolygonEpsg27700PolygonToJSON;
exports.titlePolygonEpsg27700PolygonFromJSON = titlePolygonEpsg27700PolygonFromJSON;
exports.titlePolygonEpsg4326PolygonToJSON = titlePolygonEpsg4326PolygonToJSON;
exports.titlePolygonEpsg4326PolygonFromJSON = titlePolygonEpsg4326PolygonFromJSON;
exports.titlePolygonToJSON = titlePolygonToJSON;
exports.titlePolygonFromJSON = titlePolygonFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const multipolygonmodel_js_1 = require("./multipolygonmodel.js");
const osgbmultipolygonmodel_js_1 = require("./osgbmultipolygonmodel.js");
const osgbpolygonmodel_js_1 = require("./osgbpolygonmodel.js");
const polygonmodel_js_1 = require("./polygonmodel.js");
/** @internal */
exports.TitlePolygonEpsg27700Polygon$inboundSchema = z.union([
    osgbpolygonmodel_js_1.OSGBPolygonModel$inboundSchema,
    osgbmultipolygonmodel_js_1.OSGBMultiPolygonModel$inboundSchema,
]);
/** @internal */
exports.TitlePolygonEpsg27700Polygon$outboundSchema = z.union([
    osgbpolygonmodel_js_1.OSGBPolygonModel$outboundSchema,
    osgbmultipolygonmodel_js_1.OSGBMultiPolygonModel$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TitlePolygonEpsg27700Polygon$;
(function (TitlePolygonEpsg27700Polygon$) {
    /** @deprecated use `TitlePolygonEpsg27700Polygon$inboundSchema` instead. */
    TitlePolygonEpsg27700Polygon$.inboundSchema = exports.TitlePolygonEpsg27700Polygon$inboundSchema;
    /** @deprecated use `TitlePolygonEpsg27700Polygon$outboundSchema` instead. */
    TitlePolygonEpsg27700Polygon$.outboundSchema = exports.TitlePolygonEpsg27700Polygon$outboundSchema;
})(TitlePolygonEpsg27700Polygon$ || (exports.TitlePolygonEpsg27700Polygon$ = TitlePolygonEpsg27700Polygon$ = {}));
function titlePolygonEpsg27700PolygonToJSON(titlePolygonEpsg27700Polygon) {
    return JSON.stringify(exports.TitlePolygonEpsg27700Polygon$outboundSchema.parse(titlePolygonEpsg27700Polygon));
}
function titlePolygonEpsg27700PolygonFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TitlePolygonEpsg27700Polygon$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TitlePolygonEpsg27700Polygon' from JSON`);
}
/** @internal */
exports.TitlePolygonEpsg4326Polygon$inboundSchema = z.union([polygonmodel_js_1.PolygonModel$inboundSchema, multipolygonmodel_js_1.MultiPolygonModel$inboundSchema]);
/** @internal */
exports.TitlePolygonEpsg4326Polygon$outboundSchema = z.union([polygonmodel_js_1.PolygonModel$outboundSchema, multipolygonmodel_js_1.MultiPolygonModel$outboundSchema]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TitlePolygonEpsg4326Polygon$;
(function (TitlePolygonEpsg4326Polygon$) {
    /** @deprecated use `TitlePolygonEpsg4326Polygon$inboundSchema` instead. */
    TitlePolygonEpsg4326Polygon$.inboundSchema = exports.TitlePolygonEpsg4326Polygon$inboundSchema;
    /** @deprecated use `TitlePolygonEpsg4326Polygon$outboundSchema` instead. */
    TitlePolygonEpsg4326Polygon$.outboundSchema = exports.TitlePolygonEpsg4326Polygon$outboundSchema;
})(TitlePolygonEpsg4326Polygon$ || (exports.TitlePolygonEpsg4326Polygon$ = TitlePolygonEpsg4326Polygon$ = {}));
function titlePolygonEpsg4326PolygonToJSON(titlePolygonEpsg4326Polygon) {
    return JSON.stringify(exports.TitlePolygonEpsg4326Polygon$outboundSchema.parse(titlePolygonEpsg4326Polygon));
}
function titlePolygonEpsg4326PolygonFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TitlePolygonEpsg4326Polygon$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TitlePolygonEpsg4326Polygon' from JSON`);
}
/** @internal */
exports.TitlePolygon$inboundSchema = z.object({
    boundary_area_square_metres: z.number().int(),
    date_polygon_created: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    date_polygon_updated: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    distance_from_property: z.number().int(),
    epsg_27700_polygon: z.nullable(z.union([
        osgbpolygonmodel_js_1.OSGBPolygonModel$inboundSchema,
        osgbmultipolygonmodel_js_1.OSGBMultiPolygonModel$inboundSchema,
    ])),
    epsg_4326_polygon: z.nullable(z.union([polygonmodel_js_1.PolygonModel$inboundSchema, multipolygonmodel_js_1.MultiPolygonModel$inboundSchema])),
    polygon_contains_property: z.boolean(),
    polygon_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "boundary_area_square_metres": "boundaryAreaSquareMetres",
        "date_polygon_created": "datePolygonCreated",
        "date_polygon_updated": "datePolygonUpdated",
        "distance_from_property": "distanceFromProperty",
        "epsg_27700_polygon": "epsg27700Polygon",
        "epsg_4326_polygon": "epsg4326Polygon",
        "polygon_contains_property": "polygonContainsProperty",
        "polygon_id": "polygonId",
    });
});
/** @internal */
exports.TitlePolygon$outboundSchema = z.object({
    boundaryAreaSquareMetres: z.number().int(),
    datePolygonCreated: z.date().transform(v => v.toISOString()),
    datePolygonUpdated: z.date().transform(v => v.toISOString()),
    distanceFromProperty: z.number().int(),
    epsg27700Polygon: z.nullable(z.union([
        osgbpolygonmodel_js_1.OSGBPolygonModel$outboundSchema,
        osgbmultipolygonmodel_js_1.OSGBMultiPolygonModel$outboundSchema,
    ])),
    epsg4326Polygon: z.nullable(z.union([polygonmodel_js_1.PolygonModel$outboundSchema, multipolygonmodel_js_1.MultiPolygonModel$outboundSchema])),
    polygonContainsProperty: z.boolean(),
    polygonId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        boundaryAreaSquareMetres: "boundary_area_square_metres",
        datePolygonCreated: "date_polygon_created",
        datePolygonUpdated: "date_polygon_updated",
        distanceFromProperty: "distance_from_property",
        epsg27700Polygon: "epsg_27700_polygon",
        epsg4326Polygon: "epsg_4326_polygon",
        polygonContainsProperty: "polygon_contains_property",
        polygonId: "polygon_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TitlePolygon$;
(function (TitlePolygon$) {
    /** @deprecated use `TitlePolygon$inboundSchema` instead. */
    TitlePolygon$.inboundSchema = exports.TitlePolygon$inboundSchema;
    /** @deprecated use `TitlePolygon$outboundSchema` instead. */
    TitlePolygon$.outboundSchema = exports.TitlePolygon$outboundSchema;
})(TitlePolygon$ || (exports.TitlePolygon$ = TitlePolygon$ = {}));
function titlePolygonToJSON(titlePolygon) {
    return JSON.stringify(exports.TitlePolygon$outboundSchema.parse(titlePolygon));
}
function titlePolygonFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TitlePolygon$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TitlePolygon' from JSON`);
}
//# sourceMappingURL=titlepolygon.js.map